import React from "react"
import CommonDetails from "../../sections/success-stories/common-details"
import Layout from "../../components/layout"
import Seo from "../../components/seo"
import superbetter1 from "../../images/sections/success-stories/superbetter/superbetter-1.webp"
import superbetter2 from "../../images/sections/success-stories/superbetter/superbetter-2.webp"
import superbetter3 from "../../images/sections/success-stories/superbetter/superbetter-3.webp"
import problemSolveImage from "../../images/sections/success-stories/superbetter/superbetter-problem-solve.webp"
import goalImage from "../../images/sections/success-stories/superbetter/superbetter-goal.webp"
import progressImage from "../../images/sections/success-stories/superbetter/superbetter-progress.webp"
import superbetterDesign1Image from "../../images/sections/success-stories/superbetter/superbetter-design-1.webp"
import superbetterDesign2Image from "../../images/sections/success-stories/superbetter/superbetter-design-2.webp"
import superbetterDevelopmentWebImage from "../../images/sections/success-stories/superbetter/superbetter-development-web.webp"
import superbetterDesignMobileImage from "../../images/sections/success-stories/superbetter/superbetter-design-mobile.webp"
import superbetterDesignWebImage from "../../images/sections/success-stories/superbetter/superbetter-design-web.webp"
import superbetterDesignTabImage from "../../images/sections/success-stories/superbetter/superbetter-design-tab.webp"
import superbetterImpactBgImage from "../../images/sections/success-stories/superbetter/superbetter-impact-bg.webp"
import achievement1 from "../../images/sections/success-stories/superbetter/achievement-1.webp"
import achievement2 from "../../images/sections/success-stories/superbetter/achievement-2.webp"
import achievement3 from "../../images/sections/success-stories/superbetter/achievement-3.webp"

const data = {
  overviewData: {
    title: "SuperBetter",
    description:
      "Ace the game of mental health with SuperBetter. Boost your emotional well-being, and improve your mental resilience with one of the best mental gamification applications.",
    matrixData: [
      {
        title: "Users",
        stat: 1000000,
      },
      {
        title: "Funded",
        stat: "Seed",
      },
      {
        title: "Userbase",
        stat: "Global",
      },
    ],
    tags: ["Mental Health", "Gaming", "E-Learning", "B2C"],
    mobileImages: [
      { url: superbetter1, label: "superbetter1" },
      { url: superbetter2, label: "superbetter2" },
      { url: superbetter3, label: "superbetter3" },
    ],
    // webImage: { url: fluent, label: "fluent" },
  },
  problemWeSolved: {
    description: (
      <div className="flex flex-col gap-3 md:gap-8">
        <p className={` `}>
          Nearly 1 out of 3 adolescents experience an anxiety disorder out of
          which 4.1% fall under the high category of anxiety level.
        </p>
        <p className={` `}>
          Our main ideology behind creating SuperBetter application was to help
          youths in dealing with mental health crises through gamification. This
          app invites its users to tackle quests similar to real life scenarios,
          set their goals, track and review their achievements.
        </p>
      </div>
    ),

    challenges: [
      "Redesigning a modern version of SuperBetter app from scratch",
      "Incorporating multiple compliances and security requirements",
      "Data Migration of millions of users from old database to new database",
    ],
    image: (
      <div className="absolute z-10 w-[280px] md:w-[340px] xl:w-[478px] bottom-[30%] md:bottom-[15%] xl:bottom-[10%] mx-auto    left-0 right-0  ">
        <img
          src={problemSolveImage}
          alt={"superbetter problem solve"}
          className="w-full  "
          loading="lazy"
        />
      </div>
    ),
  },
  beginning: {
    description:
      "The application has been designed and developed in a way that helps its users to invest and exchange in gold digitally. It also provides a portal for partnering networks. This platform provides its customers 100% security when it comes to privacy.",

    image: { url: goalImage, label: "project goal" },
  },
  progress: {
    description: (
      <div className="flex flex-col gap-3 md:gap-8">
        <p className={` `}>
          For UX design, we started with brainstorming and mind mapping
          techniques & for UI design keeping in mind the brand guidelines
          provided a unique digital experience. We built a prototype based on
          all the aesthetic design of all visual elements.
        </p>
      </div>
    ),

    image: { url: progressImage, label: "timeline graph" },
  },
  designJourney: {
    description: (
      <div className="flex flex-col gap-3 md:gap-8">
        <p className={` `}>
          To redesign the modern version of the application, we began with
          brainstorming and mind mapping sessions to gain valuable insights into
          the user journey. Using the outcomes from this initial stage, we
          developed the user flow and wireframes.
        </p>
        <p className={` `}>
          Aligned with the brand guidelines and aimed at delivering a unique
          digital experience, our efforts centered on UI testing, crafting
          graphic elements, and building the UI interface and prototype.
        </p>
      </div>
    ),

    topImage: {
      url: superbetterDesign1Image,
      label: "top image",
      topLabel: "Stay strong, Build your resilience",
    },
    bottomImage: {
      url: superbetterDesign2Image,
      label: "bottom image",
      bottomLabel: "And start battling your fears",
    },
  },
  developmentJourney: {
    description: (
      <div className="flex flex-col items-start gap-8 md:gap-14">
        <div className="flex flex-col items-start gap-1 md:gap-2">
          <h2 className="text-[1.5rem] ">Gamification</h2>
          <div className="flex flex-col gap-2 md:gap-6 items-start">
            <p>
              Incorporated engaging elements such as Progress Statistics,
              Reflections, Power-Ups, Daily Win Streaks, and Achievement Badges
              to deliver a complete gamified experience.
            </p>
            <p>
              These features were carefully designed to keep users motivated and
              invested, offering consistent rewards and recognition to enhance
              the sense of accomplishment throughout their journey.
            </p>
          </div>
        </div>
        <div className="flex flex-col items-start gap-1 md:gap-2">
          <h2 className="text-[1.5rem] ">Branding</h2>
          <div className="flex flex-col gap-2 md:gap-6 items-start">
            <p>
              Utilized a vibrant color palette to distinguish activities,
              aligning with SuperBetter’s brand identity and values.
            </p>
            <p>
              The use of bright, mood-enhancing colors not only uplifted the
              overall user experience but also reinforced the platform’s
              commitment to positivity and motivation
            </p>
          </div>
        </div>
      </div>
    ),

    webImage: {
      url: superbetterDevelopmentWebImage,
      label: "safegod web image",
    },
  },
  achievement: {
    tags: ["Mental Health", "Gamification", "Guided Tutorials"],
    description: (
      <ul className="list-disc ml-6 list-outside space-y-2">
        <li>
          Developed a gamified system designed to reward users and enhance
          morale. This system incorporated engaging elements like badges,
          points, and leaderboards, creating an enjoyable experience that
          motivates users to stay active and involved.
        </li>
        <li>
          Delivered a multi-layered progression system that fosters a sense of
          achievement by completing challenges and daily tasks. The progression
          system was designed with increasing complexity, providing users with a
          structured journey that continuously inspires growth and
          accomplishment.
        </li>
        <li>
          Designed a guided tutorial to ensure a seamless and intuitive user
          experience. The tutorial provided step-by-step instructions, enabling
          users to quickly understand the platform's features and navigate
          effortlessly from the start.
        </li>
      </ul>
    ),
    imageSection: (
      <div className="relative h-[80%] w-[800px]">
        <div className="absolute bottom-[50%] z-[1] top-0 left-0">
          <img
            src={achievement3}
            className="w-full h-full"
            alt={"achievement-1"}
            loading="lazy"
          />
          <div className="text-gray-1000 absolute opacity-[50%] whitespace-nowrap pl-2 left-[100%] top-0">
            Upgrade Anytime
          </div>
        </div>
        <div className="absolute top-[10%] right-[10%] left-[10%]">
          <img
            src={achievement2}
            className="w-full h-full"
            alt={"achievement-2"}
            loading="lazy"
          />
          <div className="text-gray-1000 absolute opacity-[50%] whitespace-nowrap pl-2 right-[0] top-[-5%]">
            Easy Invitation
          </div>
        </div>
        <div className="absolute bottom-0 top-[50%] right-0">
          <img
            src={achievement1}
            className="w-full h-full"
            alt={"achievement-3"}
            loading="lazy"
          />
          <div className="text-gray-1000 absolute opacity-[50%] whitespace-nowrap pr-2 right-[100%] bottom-[0]">
            Guided Tasks
          </div>
        </div>
      </div>
    ),
  },
  designs: {
    firstSection: {
      title: "Engagement as Key",
      description:
        "The onboarding process was thoughtfully designed to maximize engagement, providing users with clear, interactive steps to familiarize themselves with the platform and its features.",
      mobileImage: {
        url: superbetterDesignMobileImage,
        label: "design mobile image",
      },
    },
    secondSection: {
      title: "Become a winner",
      description: `Begin your mental healthcare journey by unleashing the potential to fight your fear. Set a time limit and choose among "quests" and "power-ups" to begin the journey of challenging yourself mentally.`,
      webImage: {
        url: superbetterDesignWebImage,
        label: "design web image",
      },
    },
    thirdSection: {
      description:
        "If you are a mentor or teacher, you can host challenges and invite group of students to motivate and help them in maintain their mental wellbeing.",
      tabImage: {
        url: superbetterDesignTabImage,
        label: "design tab image",
      },
    },
  },
  impact: {
    label: "Empowering Experiences",
    description:
      "The core ideology behind creating the SuperBetter application was to support young people in navigating mental health challenges through the power of gamification. The app engages users by inviting them to complete quests inspired by real-life scenarios, set meaningful goals, and track their progress. By reviewing their achievements, users are encouraged to build resilience and foster a positive outlook while making mental health management an interactive and rewarding experience.",
    backgroundImage: superbetterImpactBgImage,
    stats: [
      { heading: 1000000, subheading: "Userbase" },
      { heading: "Seed", subheading: "Funded" },
      { heading: "Leading", subheading: "Mental Health platform Globally" },
      { heading: "Publications", subheading: "Covered by various publishers" },
    ],
  },
}

const SuperBetter = () => {
  return (
    <Layout>
      <Seo
        title="SuperBetter | Brim Labs' impact in Mental Health Innovation"
        description="Explore Brim Labs’s contribution to SuperBetter’s mental health gamification platform, enhancing emotional well-being and resilience through innovative app development."
        keywords="SuperBetter success, mental health app, gamification platform, emotional resilience, Brim Labs innovation, mental well-being, app development, health tech, digital wellness, mental health solutions"
      />
      <CommonDetails data={data} />
    </Layout>
  )
}

export default SuperBetter
